import { useEffect, useState } from "react";
import { FileInfo } from "./lib";
import findVideos from "ighar";

interface Props {
  fileInfo: FileInfo;
  setIsProcessing: (isProcessing: boolean) => void;
}

interface Video {
  filename: string;
  dataUrl: string;
}

const getVideos = (harFileContent: string): Video[] => {
  const res = findVideos(harFileContent, { verbose: false }).map(({ filename, output }) => {
    const dataUrl = `data:video/mp4;base64,${output.toString("base64")}`;
    return { filename, dataUrl };
  });
  return res;
};

const HarFileInfo = (props: Props) => {
  const { fileInfo, setIsProcessing } = props;

  const [videos, setVideos] = useState<Video[]>([]);

  useEffect(() => {
    setIsProcessing(true);
    const videos = getVideos(fileInfo.text);
    setIsProcessing(false);
    setVideos(videos);
  }, []);

  console.log("videos", videos);

  return <>
    <ol>
      {videos.map(({ filename, dataUrl }) => (
        <li key={filename}>
          <a href={dataUrl} download={filename}>{filename}</a>
        </li>
      ))}
    </ol>
  </>

};
export default HarFileInfo;